module.exports = __webpack_public_path__ + "img/Recurso 22@300x.379be657.png";